import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatCheckboxChange, MatStepper, MatTableDataSource} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SelectionModel} from '@angular/cdk/collections';
import {CommonService} from '../../services/common.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import * as moment from 'moment';
import {ActionCompletionDialogComponent} from '../../common/action-completion-dialog/action-completion-dialog.component';

moment.locale('el-GR');

interface Refrigerator {
  id: number;
  serial_number: string;
  material_id: string;
  material_name: string;
  batch_id: number;
  batch_name: string;
  eikastiko_id: string;
  eikastiko_name: string;
  weight_net: number;
  model_id: string;
  model_name: string;
  quality_id: string;
  quality_name: string;
  manufacturer_id: string;
  manufacturer_name: string;
  equipment_id: string;
  sale_point_id: number;
  sale_point_customer_name: string;
  sale_point_customer_code: string;
  sales_group_id: string;
  sales_group_description: string;
  is_new: number;
  phase_id: number;
  is_active: number;
  can_be_loaded: number;
  can_be_received: number;
  can_be_returned: number;
  can_be_unloaded: number;
}

@Component({
  templateUrl: './create-return-request-dialog.component.html'
})
export class CreateReturnRequestDialogComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('paginatorRefrigerator', {static: true}) paginatorRefrigerator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  public cardContainerHeight: any;
  public cardContainerWidth: any;
  public comments: string;
  public reason: any;
  public isLoading: boolean;
  public itemsLoading = false;
  public refrigeratorsDataSource: MatTableDataSource<Refrigerator>;
  public refrigeratorDisplayColumns: string[] = ['select', 'serial_number', 'material_id', 'material_name', 'batch_name', 'model_name', 'sale_point_customer_name'];
  public returnDate: any;
  public selectionRefrigerator: SelectionModel<any>;
  public selectedRefrigerators: any;
  public tableContainerHeight: any;
  public tableHeight: any;
  public returnReasons: any;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CreateReturnRequestDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.refrigeratorsDataSource = new MatTableDataSource<Refrigerator>();
    this.selectionRefrigerator = new SelectionModel<any>(true, []);
    this.cardContainerHeight = window.innerHeight - 200;
    this.tableContainerHeight = window.innerHeight - 350;
    this.tableHeight = this.tableContainerHeight - 150;
  }

  public async ngOnInit(): Promise<any> {
      try {
        this.isLoading = true;
        this.returnReasons = await this.commonService.getSimpleList(`return_reason`);
        this.refrigeratorsDataSource.data = await this.commonService.getSimpleList(`refrigerator/refrigerator2?filter=sale_point_id=${this.data.sale_point_id} AND phase_id=5`) as Refrigerator[];
        this.refrigeratorsDataSource.paginator = this.paginatorRefrigerator;
      } catch (e) {
      } finally {
        this.isLoading = false;
      }
  }

  public applyRefrigeratorFilter(filterValue: string): void {
    this.refrigeratorsDataSource.filter = filterValue.trim().toLowerCase();
  }

  public isFirstStepInvalid(): boolean {
    return this.selectionRefrigerator.selected.length === 0;
  }

  public isSecondStepInvalid(): boolean {
    return this.returnDate === undefined || this.reason === undefined;
  }

  public next(): void {
    this.selectedRefrigerators = [];
    if (this.stepper.selectedIndex === 1) {
      this.selectionRefrigerator.selected.forEach(refrigerator => {
        const model = {
          serial_number: refrigerator.serial_number,
          material_name: refrigerator.material_name,
          model_name: refrigerator.model_name,
        };
        this.selectedRefrigerators.push(model);
      });
    }
    this.stepper.next();
  }

  public previous(): void {
    this.stepper.previous();
  }

  public returnFormattedDate() {
    return moment(this.returnDate).format('L');
  }

  public async submit(): Promise<void> {
    const refrigeratorList = [];
    this.selectionRefrigerator.selected.forEach(refrigerator => {
      refrigeratorList.push({
        material_id: refrigerator.material_id,
        serial_number: refrigerator.serial_number
      });
    });

    const model = {
      applicant_sale_point_id: this.data.sale_point_id,
      desired_delivery_date: this.returnDate,
      comments: this.comments === undefined ? null : this.comments,
      key_account_id: this.data.key_account_id,
      return_reason_id: this.reason ? this.reason.id : -1,
      details: refrigeratorList
    };

    try {
      this.itemsLoading = true;
      await this.commonService.insertObject('return_command/web', model);
      const dialog = this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις επιστροφές ψυγείων',
          redirectURL: `returns`
        }
      });
      dialog.afterClosed().subscribe(() => {
        this.matDialogRef.close();
      });
    } catch (e) {
    } finally {
      this.itemsLoading = false;
    }
  }

  public selectionRefrigeratorChanged(event: any, row: any) {
    if (event.checked === false || this.selectionRefrigerator.isSelected(row)) {
      return this.selectionRefrigerator.deselect(row);
    } else {
      return this.selectionRefrigerator.select(row);
    }
  }
}
